"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _excluded = ["width", "height", "color"];

var BookmarkOutlineOff = function BookmarkOutlineOff(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    fill: color,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _preact.h)("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.10421 2.07682L2.07817 2.10547L21.8737 21.901L20.4766 23.2995L17.5599 20.3828L12 18L5.00004 21L5.00785 7.83073L0.677124 3.5L2.1016 2.07422L2.10421 2.07682ZM7.00004 18L12 15.8203L13.7683 16.5911L7.00004 9.82292V18Z",
    fill: "#5F6C7A"
  }), (0, _preact.h)("path", {
    d: "M17 3C18.1 3 19 3.9 19 5V16.1771L17 14.1771V5H7.82296L6.05994 3.23698C6.33974 3.08561 6.65995 3 7.00004 3H17Z",
    fill: "#5F6C7A"
  }));
};

var _default = BookmarkOutlineOff;
exports.default = _default;